/* eslint-disable @tencent/i18next/no-literal-string */
/* eslint-disable no-underscore-dangle */
import { statusReport007 } from '@src/slide/infrastructure/module/dependent/report/real-time-report/real-time';
import {
    Reporter007,
    Reporter007ActionType,
} from '@src/slide/infrastructure/module/dependent/report/real-time-report/constant';
import {
    TDWOperationType,
    TDWModuleType,
    TDWActionType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';

function clientVarsMonitor() {
    if (global.clientVars) {
        global.log?.info('[key process]', 'PPT JSON Ready at now');
        statusReport007(Reporter007ActionType.OPEN_DOC_FAILURE, Reporter007.ERROR);
    } else {
        global.addEventListener('dataReady', () => {
            global.log?.info('[key process]', 'PPT JSON Ready on event');
            statusReport007(Reporter007ActionType.OPEN_DOC_FAILURE, Reporter007.ERROR);
        });
        global.addEventListener('dataError', (e: any) => {
            global.log?.info('[key process]', 'PPT JSON Error on event');
            try {
                tdw({
                    opername: TDWOperationType.DOC_PERFORMANCE,
                    module: TDWModuleType.PERFORMANCE_DETAIL,
                    action: TDWActionType.PERFORMANCE_DATA_ERROR,
                    ver6: JSON.stringify({
                        retcode: e?.detail?.retcode,
                        userAgent: global?.navigator?.userAgent,
                        href: global?.location?.href,
                    }),
                });
                // 以下code码是符合预期的，无需上报
                // 200801：未登录访问安全水印、200404：slide文档被举报、200407：没有读权限
                const ignoreErrorList = ['200801', '200404', '200407', 'xhr-error-0'];
                if (ignoreErrorList.includes(String(e?.detail?.retcode))) {
                    // 全局标注接口异常为预期内的，white-screen-check判断页面没有正常渲染时需忽略此原因引发的场景
                    global.knownApiError = true;
                    return;
                }
            } catch (err) {
                window.log?.error('dataError tdw report failed');
            }
            const matchRes = location.pathname.match(/slide\/([A-Za-z]+)/);
            statusReport007(Reporter007ActionType.OPEN_DOC_FAILURE, Reporter007.SUCCESS, '', [e?.detail?.retcode, matchRes?.[1]]);
        });
    }
}


clientVarsMonitor();
